<template>
  <el-container
    id="app"
    :class="{ 'menu-collapsed': isCollapsed, 'is-mobile': isMobile }"
    v-loading="isVerifying"
  >
    <el-header id="main-nav">
      <MainNav />
    </el-header>
    <template v-if="isMobile">
      <MobileMenu />
    </template>
    <el-container id="content-wrapper">
      <template v-if="!isMobile">
        <el-aside id="side-nav">
          <SideNav v-if="user && user.user_type != 4" />
          <SupervisorNav v-if="user && user.user_type == 4"></SupervisorNav>
        </el-aside>
      </template>

      <el-main id="content"> <router-view></router-view></el-main>
    </el-container>
  </el-container>
</template>
<script>
import MainNav from "@/components/MainNav";
import SideNav from "@/components/SideNavbar";
import MobileMenu from "@/components/MobileMenu.vue";
import SupervisorNav from "@/components/SupervisorNav.vue";
import { isMobile } from "mobile-device-detect";
export default {
  components: { MainNav, SideNav, MobileMenu, SupervisorNav },
  computed: {
    isCollapsed() {
      return this.$store.getters["ui/collapse"];
    },
    user() {
      return this.$store.getters["auth/user"];
    }
  },
  data: () => ({
    isVerifying: true,
    isMobile
  }),
  methods: {},
  mounted() {
    if (this.$route.name != "login") {
      this.isVerifying = true;
      this.$store.dispatch("auth/getUserInfo").then(resp => {
        if (resp === null) {
          this.$router.push({ name: "login" });
        }
        this.isVerifying = false;
      });
    }
    this.isVerifying = false;
  }
};
</script>
